import { useTranslation } from 'next-i18next';
import { useRouter } from 'next/router';
import React, { ReactNode } from 'react';
import styled from 'styled-components';

interface ChildProps {
  displayNew?: boolean;
  icon: ReactNode;
  label: string;
  clickHandler: () => void;
}

const EntityDetail = ({
  displayNew,
  icon,
  label,
  clickHandler
}: ChildProps): JSX.Element => {
  const { locale } = useRouter();
  const { t } = useTranslation('entity');
  return (
    <DetailItem onClick={clickHandler} locale={locale}>
      {icon}
      <span className={`text-2 ${displayNew ? 'map-text' : ''}`}>{label}</span>
    </DetailItem>
  );
};

const DetailItem = styled.div<any>`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-width: 125px;
  height: 80px;
  border: 1px solid #e4ebf2;
  border-radius: ${props => props.theme.borderRadius};
  cursor: pointer;
  transition: all 0.2s ease-out;
  position: relative;

  span {
    margin-top: 4px;
    font-size: 14px;
    color: ${props => props.theme.light.colors.black};

    &.map-text {
      position: relative;
      &::after {
        content: ${props => (props.locale === 'ar' ? '"جديد"' : '"New"')};
        position: absolute;
        top: -40px;
        display: flex;
        justify-content: center;
        align-items: center;
        left: ${props => (props.locale == 'en' ? '-6px' : 'unset')};
        color: ${props => props.theme.light.colors.white};
        background-color: ${props => props.theme.light.colors.primaryOrange};
        width: 26px;
        height: 12px;
        border-radius: 100px;
        color: #fff;
        text-align: center;
        font-family: materialRegular;
        font-size: 8px;
        text-transform: capitalize;
      }
    }
  }
  @media (hover: hover) and (pointer: fine) {
    &:hover {
      border: 1px solid ${props => props.theme.light.colors.tertiary};
    }
  }
`;
export default EntityDetail;
